<template>
    <div class="score-explained">
        <p>
            {{ $translate('cycle_report_score_explained') }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'ScoreExplained'
}
</script>

<style lang="scss" scoped>
.score-explained {
    p {
        font-size: 12px;
        margin-bottom: 0;
    }
}
</style>
